var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, MessageBox, TextBox, useModal, } from "@animech/ui";
import * as Styled from "./saved-systems.style";
import { SavedSystemsSearchResults } from "./search-results";
import { TabHeader } from "ui/components/panels/home-menu/tabs/tab-header";
import { CloseIcon } from "ui/components/elements/icons/close";
import { clearURLParameter, getURLParameter, PageRoute } from "utility/url";
import { ApplicationFilter } from "ui/components/panels/home-menu/tabs/saved-systems/application-filter";
import { SavedSystemSelect } from "ui/components/panels/home-menu/tabs/saved-systems/system-select";
import { actions, selectors, useAppDispatch, useAppSelector } from "store";
import { LoadingOverlay } from "ui/components/elements/loading-overlay";
import { useConfigIdContext } from "providers/config-id";
import { FolderBreadcrumbs } from "ui/components/panels/home-menu/tabs/saved-systems/breadcrumbs";
import { CreateFolderModal } from "ui/components/modals/ovm-backend/create-folder-modal/create-folder-modal";
import { claimSystemParameterName } from "utility/constants";
import { ClaimSystemModal } from "ui/components/modals/ovm-backend/claim-system-modal/claim-system-modal";
export var SavedSystemsTab = function () {
    var _a = useConfigIdContext(), startConfig = _a.startConfig, ticket = _a.ticket;
    var _b = __read(useState(), 2), claimedSystemId = _b[0], setClaimedSystemId = _b[1];
    var _c = useAppSelector(selectors.selectUserRoot), activeSystem = _c.activeSystem, userSystems = _c.systems, folders = _c.folders, userId = _c.userId;
    var isLoading = useAppSelector(selectors.selectIsUserDataLoading);
    var activeFolderId = useAppSelector(selectors.selectActiveFolderId);
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var t = useTranslation().t;
    var openModal = useModal();
    var _d = __read(useState(), 2), dragSource = _d[0], setDragSource = _d[1];
    var _e = __read(useState(""), 2), searchQuery = _e[0], setSearchQuery = _e[1];
    var _f = __read(useState(), 2), highlightedSystemId = _f[0], setHighlightedSystemId = _f[1];
    // `undefined` means "all applications" (no filter).
    var _g = __read(useState(), 2), selectedApplication = _g[0], setSelectedApplication = _g[1];
    var isApplicationFilterActive = selectedApplication !== undefined;
    var isSearching = searchQuery.trim().length > 0 || isApplicationFilterActive;
    var claimId = getURLParameter(claimSystemParameterName);
    useEffect(function () {
        if (!claimId || !userId)
            return;
        var handle = undefined;
        var onSystemClaimed = function (claimedId) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dispatch(actions.getUserSystems())];
                    case 1:
                        _a.sent();
                        setClaimedSystemId(claimedId);
                        handle && handle.close();
                        return [2 /*return*/];
                }
            });
        }); };
        var onSystemOpened = function () {
            handle && handle.close();
            startConfig(ticket);
            navigate(PageRoute.SYSTEM_DESIGN);
        };
        clearURLParameter(claimSystemParameterName);
        handle = openModal(_jsx(ClaimSystemModal, { onSystemClaimed: onSystemClaimed, onSystemOpened: onSystemOpened, systemId: claimId, userId: userId }));
    }, [claimId, dispatch, navigate, openModal, startConfig, ticket, userId]);
    var onDrop = useCallback(function (sourceId, targetFolderId) {
        var system = userSystems.find(function (system) { return system.id === sourceId; });
        var folder = folders.find(function (folder) { return folder.id === sourceId; });
        if (!system && !folder)
            return;
        if (system) {
            dispatch(actions.saveSystem(__assign(__assign({}, system), { folderId: targetFolderId })));
        }
        else if (folder) {
            dispatch(actions.saveFolder(__assign(__assign({}, folder), { parentId: targetFolderId })));
        }
    }, [userSystems, folders, dispatch]);
    var canDrop = useCallback(function (source, target) {
        return source !== target && folders.map(function (folder) { return folder.id; }).includes(target);
    }, [folders]);
    var errorFetchingUserSystems = useMemo(function () {
        // User has not yet been authenticated, no need to display any errors.
        if (!userId || isLoading) {
            return;
        }
        if (!userSystems) {
            return true;
        }
        return;
    }, [isLoading, userId, userSystems]);
    // Fetch user systems once initially as soon as the user is authenticated.
    useEffect(function () {
        if (!userId) {
            return;
        }
        var loadSystems = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(actions.getUserSystems())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); };
        loadSystems();
    }, [dispatch, userId]);
    var onLoadSystemState = useCallback(function (system) { return __awaiter(void 0, void 0, void 0, function () {
        var success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(actions.loadSystemState(system))];
                case 1:
                    success = _a.sent();
                    if (success) {
                        navigate(PageRoute.SYSTEM_DESIGN);
                    }
                    startConfig(ticket);
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, navigate, startConfig, ticket]);
    var onShowInFolder = useCallback(function (system) {
        // Exit search mode entirely (clear both the name query and the
        // application filter) so the folder browser can take over.
        setSearchQuery("");
        setSelectedApplication(undefined);
        setHighlightedSystemId(system.id);
        dispatch(actions.setActiveFolderId(system.folderId));
    }, [dispatch]);
    var onBreadcrumbDrop = useCallback(function (targetFolderId) {
        return dragSource && onDrop(dragSource, targetFolderId);
    }, [onDrop, dragSource]);
    return (_jsxs(Styled.SavedSystemsTab, { children: [_jsxs(Styled.TabHeaderContainer, { children: [_jsx(TabHeader, { header: t("home-menu.saved-systems.header") }), _jsx(Styled.SystemNameContainer, { children: activeSystem && (_jsx(Styled.SystemName, { children: activeSystem.name })) }), _jsx(Styled.ButtonContainer, { children: _jsx(Button, { appearance: "ghost", onClick: function () {
                                openModal(_jsx(CreateFolderModal, {}));
                            }, children: t("home-menu.saved-systems.new") }) })] }), _jsxs(Styled.SearchContainer, { children: [_jsx(TextBox, { type: "search", icon: "magnify", value: searchQuery, onValueChange: setSearchQuery, placeholder: t("home-menu.saved-systems.search-placeholder"), instantValueChange: true }), searchQuery.length > 0 && (_jsx(Styled.ClearSearchButton, { type: "button", "aria-label": t("home-menu.saved-systems.clear-search"), onClick: function () { return setSearchQuery(""); }, children: _jsx(CloseIcon, { size: "16" }) }))] }), _jsx(ApplicationFilter, { selected: selectedApplication, onChange: setSelectedApplication }), !isSearching && (_jsx(FolderBreadcrumbs, { folders: folders, activeFolderId: activeFolderId, onDrop: onBreadcrumbDrop })), errorFetchingUserSystems && (_jsxs(_Fragment, { children: [_jsx(MessageBox, { color: "alert", children: t("home-menu.saved-systems.fetch-error") }), _jsx(Button, { onClick: function () { return dispatch(actions.getUserSystems()); }, children: "Refresh" })] })), userSystems && userSystems.length === 0 && !isLoading && !isSearching ? (_jsx(Styled.EmptyText, { children: t("home-menu.saved-systems.empty") })) : null, userSystems && isSearching && (_jsx(SavedSystemsSearchResults, { systems: userSystems, folders: folders, query: searchQuery, selectedApplication: selectedApplication, onOpen: onLoadSystemState, onShowInFolder: onShowInFolder })), userSystems && !isSearching && (_jsx(SavedSystemSelect, { folders: folders, onSelectedSystemConfirmed: onLoadSystemState, systems: userSystems, draggedItem: dragSource, canDrop: canDrop, onDragStart: setDragSource, onDrop: onDrop, highlightSystemId: highlightedSystemId !== null && highlightedSystemId !== void 0 ? highlightedSystemId : claimedSystemId })), isLoading && _jsx(LoadingOverlay, {})] }));
};
